namespace Matrix.Workflow {
    export class DiffViewColumns {
        static columnsKey = 'Workflow.DiffView';
    }
}
